import script from "./CalendarioFbochasComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarioFbochasComponent.vue?vue&type=script&setup=true&lang=js"

import "./CalendarioFbochasComponent.vue?vue&type=style&index=0&id=0661b48d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0661b48d"]])

export default __exports__